export default __webpack_public_path__ + "static/media/camera-btn-icon.70b0236c.svg";